{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Δείτε όλες τις επιλογές",
  "Spoiler_Reveal_Tooltip": "Κάντε κλικ για εμφάνιση",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Στείλτε Tweet με αυτό",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Το στοιχείο έχει συμπτυχθεί",
  "Spoiler_Reveal_Video_CTA": "Εμφάνιση του βίντεο",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Ανάπτυξη εικόνας",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Δείτε όλα τα αποτελέσματα",
  "Spoiler_Reveal_Image_Placeholder": "Αυτή η εικόνα περιέχει σπόιλερ",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Ρυθμιστικό αναζήτησης",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Μπορείτε να ψηφίσετε περισσότερες από μία απαντήσεις.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Εμφάνιση περισσότερων στοιχείων ελέγχου ήχου",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Κλείσιμο",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Φόρτωση {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "User avatar",
  "Preview_ReadMore_Label": "Διαβάστε περισσότερα",
  "Spoiler_Insert_Tooltip": "Σπόιλερ",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Ένταση",
  "Spoiler_Reveal_Gallery_Placeholder": "Αυτή η συλλογή περιέχει σπόιλερ",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Κάντε κράτηση τώρα",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Κατάργηση σίγασης",
  "Spoiler_Reveal_Gallery_CTA": "Εμφάνιση της συλλογής",
  "Poll_Viewer_ShowLess_CTA": "Εμφάνιση λιγοτέρων",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Σίγαση",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} ανώνυμος",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Ακολουθήστε",
  "VerticalEmbed_Products_Button": "Αγορά τώρα",
  "Poll_Viewer_Toast_Error_ServerDown": "Δεν ήταν δυνατή η σύνδεση με τον διακομιστή. Προσπαθήστε πάλι αργότερα.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} άτομο ψήφισε υπέρ αυτής της απάντησης",
  "Poll_Viewer_VoteCount": "{{number}} ψήφοι",
  "VerticalEmbed_Events_Button": "Εγγραφείτε τώρα",
  "Spoiler_Reveal_Image_CTA": "Εμφάνιση της εικόνας",
  "Poll_Viewer_Toast_Error_Connection": "Δεν υπάρχει σύνδεση στο Διαδίκτυο. Ελέγξτε τη σύνδεσή σας.",
  "Poll_Viewer_Visibility_Owner_Footer": "Μόνο εσείς μπορείτε να δείτε τα αποτελέσματα.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} άτομα ψήφισαν υπέρ αυτής της απάντησης",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Το στοιχείο επεκτάθηκε",
  "Audio_Plugin_Cover_Alt": "Audio cover",
  "Spoiler_Reveal_Video_Placeholder": "Αυτό το βίντεο περιέχει σπόιλερ",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Δείτε την πλήρη ανάρτηση",
  "UploadFile_Viewer_Download": "Λήψη {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}}ω",
  "VerticalEmbed_Units_Minute": "{{minutes}} λεπτά",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
